"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LayoutSelectionPageInfo = void 0;
var LayoutSelectionPageInfo = (function () {
    function LayoutSelectionPageInfo() {
        this.oldItems = [];
        this.newItems = [];
        this.isChanged = false;
    }
    LayoutSelectionPageInfo.prototype.beforeRecreatePageSelection = function () {
        this.newItems = [];
        this.isChanged = this.oldItems.length > 0;
    };
    LayoutSelectionPageInfo.prototype.changesCollected = function () {
        if (this.isChanged) {
            this.oldItems = this.newItems;
            this.newItems = [];
            this.isChanged = false;
        }
    };
    return LayoutSelectionPageInfo;
}());
exports.LayoutSelectionPageInfo = LayoutSelectionPageInfo;
